import React from 'react'

import { LeftArrowCircleIcon, RightArrowCircleIcon } from 'images'
import noImage from 'images/no-image.png'

import classnames from 'classnames'
import { filesize } from 'filesize'

const ExpandedModal = (props) => {
  const { expandedImage, onBack, onNext, isFirstItem, isLastItem } = props
  const isVideoMedia = expandedImage?.type?.startsWith?.('video/')

  if (!expandedImage) return null
  
  return (
    <div className="media-uploads_preview">
      <div>
        <div className="media-uploads_preview_image">
          {isVideoMedia ? (
            <video
              src={expandedImage.preview || expandedImage.url}
              muted
              controls
              playsInline
            />
          ) : (
            <img src={expandedImage.preview || expandedImage.url || noImage} alt={expandedImage.name || 'No image'} />
          )}
        </div>
          
        <div className="media-uploads_preview_header">
          <p>{expandedImage.filename ?? expandedImage.name}</p>
          <p>{filesize(expandedImage.size || 0)}</p>
        </div>
      </div>

      <div className="media-uploads_preview_wrapper">
        <footer className="media-uploads_preview_navigation">
          <LeftArrowCircleIcon
            onClick={() => onBack(expandedImage)}
            className={classnames('left', { disabled: isFirstItem })}
          />

          <RightArrowCircleIcon
            onClick={() => onNext(expandedImage)}
            className={classnames('right', { disabled: isLastItem })}
          />
        </footer>
      </div>
    </div>
  )
}

export default ExpandedModal